export const DEFAULT_ERROR_MSG = 'Something went wrong';
